import { render, staticRenderFns } from "./EmailBroadcastPage.vue?vue&type=template&id=f67d58fe&scoped=true"
import script from "./EmailBroadcastPage.vue?vue&type=script&lang=js"
export * from "./EmailBroadcastPage.vue?vue&type=script&lang=js"
import style0 from "./EmailBroadcastPage.vue?vue&type=style&index=0&id=f67d58fe&prod&lang=css"
import style1 from "./EmailBroadcastPage.vue?vue&type=style&index=1&id=f67d58fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67d58fe",
  null
  
)

export default component.exports